import { render } from "./ProcessoDistribuicaoLote.vue?vue&type=template&id=1846c927&scoped=true"
import script from "./ProcessoDistribuicaoLote.vue?vue&type=script&lang=js"
export * from "./ProcessoDistribuicaoLote.vue?vue&type=script&lang=js"

import "./ProcessoDistribuicaoLote.vue?vue&type=style&index=0&id=1846c927&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1846c927"]])

export default __exports__